import { useNavigate } from "react-router-dom"
import MTable from "../../../../components/mtable"
import CollapsingSection from "../../../../components/CollapsingSection"
import { formatEnum } from "../../../../utils/strings"

export default function CompanyQuestionnaires({ companyId }) {

    const navigate = useNavigate()

    const mapper = { columns: [
        {
            label: "Name",
            style: "full",
            value: (item) => item.name
        },
        {
            label: "Questions Count",
            value: (item) => item.questionsCount,
            width: "0.5fr"
        },
        {
            label: "Status",
            value: (item) => item?.status ? formatEnum(item?.status ?? '') : '--'
        }
    ]}

    return (
        <CollapsingSection
            title="Questionnaires"
            actionButtons={<button className="text" onClick={() => navigate('manage-questionnaires')}>Manage Access</button>}
        >
            <MTable path={'questionnaires'} queryParams={{ companyId }} mapper={mapper} />
        </CollapsingSection>
    )
}
